"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeContributionsData = exports.putContributionsData = exports.removePersistentData = exports.putPersistentData = void 0;
const putPersistentData_1 = __importDefault(require("./putPersistentData"));
exports.putPersistentData = putPersistentData_1.default;
const removePersistentData_1 = __importDefault(require("./removePersistentData"));
exports.removePersistentData = removePersistentData_1.default;
const putContributionsData_1 = __importDefault(require("./putContributionsData"));
exports.putContributionsData = putContributionsData_1.default;
const removeContributionsData_1 = __importDefault(require("./removeContributionsData"));
exports.removeContributionsData = removeContributionsData_1.default;
//# sourceMappingURL=index.js.map